import { themeLight } from "./theme-light";

export enum ThemeType {
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export function themeCreator(theme: any) {
  return themeMap[theme];
}
const themeMap = {
  // [ThemeType.DARK]: themeDark,
  [ThemeType.LIGHT]: themeLight,
  [ThemeType.DARK]: themeLight,
};
